import React, { Fragment, useState, useEffect } from 'react'

import Loading from 'Loading'
import { useDispatch, useSelector } from 'react-redux'

import { menuLoadBoxPrices } from 'actions/menu'
import { trackUTMAndPromoCode } from 'actions/tracking'
import { boxPricesClickTab } from 'actions/trackingKeys'
import { boxTypes, getHeroDetails } from 'routes/BoxPrices/boxPricesConfig'

import { BoxPricesContent } from './BoxPricesContent'
import { BoxPricesList } from './BoxPricesList'
import { BoxPricesTabs } from './BoxPricesTabs'
import { BoxTypesValue, NumPersonsToBoxDescriptors } from './boxPricesModels'
import {
  getNumPersonsToBoxDescriptors,
  getMenuBoxPricesRecieve,
  getError,
} from './boxPricesSelectors'

import css from './BoxPrices.css'

const BoxPricesComponent = () => {
  const dispatch = useDispatch()

  const loading = useSelector(getMenuBoxPricesRecieve)
  const error = useSelector(getError)

  const numPersonsToBoxDescriptors = useSelector(
    getNumPersonsToBoxDescriptors,
  ) as NumPersonsToBoxDescriptors

  const dispatchTrackUTMAndPromoCode = (
    boxPricesClickTabArg: string,
    boxSizeTrackingValue: string,
  ) =>
    dispatch(
      trackUTMAndPromoCode(boxPricesClickTabArg, {
        box_size: boxSizeTrackingValue,
      }),
    )

  const [activeIndex, setActiveIndex] = useState(0)

  const boxTypeConfigsArray: BoxTypesValue[] = Object.values(boxTypes)
  const labels: string[] = boxTypeConfigsArray.map(({ title }) => title)

  const handleSetActiveTabIndex = (index: number) => {
    const { boxSizeTrackingValue } = boxTypeConfigsArray[index]
    dispatchTrackUTMAndPromoCode(boxPricesClickTab, boxSizeTrackingValue)
    setActiveIndex(index)
  }

  useEffect(() => {
    dispatch(menuLoadBoxPrices())
  }, [dispatch])

  return (
    <Fragment>
      {loading && (
        <div className={css.loadingOverlay}>
          <Loading />
        </div>
      )}
      <div className={loading ? css.loading : ''}>
        <h1 className={css.header}>{getHeroDetails().header}</h1>
        {!loading && (
          <Fragment>
            <BoxPricesTabs
              activeIndex={activeIndex}
              labels={labels}
              setActiveIndex={handleSetActiveTabIndex}
            />
            <BoxPricesList
              numPersonsToBoxDescriptors={numPersonsToBoxDescriptors}
              selectedBox={boxTypeConfigsArray[activeIndex].value}
              error={error}
            />
          </Fragment>
        )}
        <BoxPricesContent />
      </div>
    </Fragment>
  )
}

export { BoxPricesComponent }
